import React, { useState } from "react";
import { ArrowRight, Search, Calendar } from "lucide-react";
import { BLOG_POSTS } from "../data/mock";

export default function Blog() {
  const [query, setQuery] = useState("");
  const filtered = BLOG_POSTS.filter(
    (p) =>
      p.title.toLowerCase().includes(query.toLowerCase()) ||
      p.category.toLowerCase().includes(query.toLowerCase())
  );
  const featured = filtered[0];
  const rest = filtered.slice(1);

  return (
    <main>
      <section className="bg-[var(--brand-hero)]">
        <div className="mx-auto max-w-4xl px-5 py-16 text-center lg:py-20 lg:px-8">
          <span className="text-sm font-bold uppercase tracking-wider text-teal-brand">Insights</span>
          <h1 className="mt-3 text-4xl font-extrabold text-navy-brand sm:text-5xl">From the Blog</h1>
          <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-slate-500">
            Tips, strategies and industry insight on inventory liquidation, reverse logistics and
            recovering capital from excess stock.
          </p>
          <div className="mx-auto mt-8 flex max-w-md items-center gap-2 rounded-full border border-slate-200 bg-white px-5 py-1.5">
            <Search size={18} className="text-slate-400" />
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search articles..."
              className="h-10 w-full bg-transparent text-sm outline-none"
            />
          </div>
        </div>
      </section>

      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        {filtered.length === 0 && (
          <p className="py-20 text-center text-slate-500">No articles match your search.</p>
        )}

        {featured && (
          <div className="mb-14 grid overflow-hidden rounded-3xl border border-slate-100 shadow-sm lg:grid-cols-2">
            <div className="h-64 overflow-hidden lg:h-auto">
              <img src={featured.image} alt={featured.title} className="h-full w-full object-cover" />
            </div>
            <div className="flex flex-col justify-center p-8 lg:p-12">
              <div className="mb-3 flex items-center gap-3 text-xs">
                <span className="rounded-full bg-teal-brand/10 px-3 py-1 font-semibold text-teal-brand">{featured.category}</span>
                <span className="flex items-center gap-1 text-slate-400"><Calendar size={13} /> {featured.date}</span>
              </div>
              <h2 className="text-2xl font-extrabold leading-snug text-navy-brand sm:text-3xl">{featured.title}</h2>
              <p className="mt-4 text-[15px] leading-relaxed text-slate-500">{featured.excerpt}</p>
              <button className="mt-6 inline-flex w-fit items-center gap-2 text-sm font-semibold text-teal-brand hover:gap-3 transition-all">
                Read Article <ArrowRight size={16} />
              </button>
            </div>
          </div>
        )}

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((p) => (
            <article
              key={p.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm transition-all duration-300 hover:-translate-y-2 hover:shadow-xl"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <div className="mb-3 flex items-center gap-3 text-xs">
                  <span className="rounded-full bg-teal-brand/10 px-3 py-1 font-semibold text-teal-brand">{p.category}</span>
                  <span className="flex items-center gap-1 text-slate-400"><Calendar size={13} /> {p.date}</span>
                </div>
                <h3 className="text-lg font-bold leading-snug text-navy-brand">{p.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-500">{p.excerpt}</p>
                <button className="mt-5 inline-flex w-fit items-center gap-2 text-sm font-semibold text-teal-brand transition-all hover:gap-3">
                  Read More <ArrowRight size={16} />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </main>
  );
}
